<template>
    <div class="porfolio page">
        <div class="page-content">
            <header class="punchline">
                <div class="container">
                    <div class="row">
                        <div class="offset-md-1 col-md-9 offset-lg-2 col-lg-8">
                            <div  id="header-text" data-lax-scale="200 1.5, 0 1"  data-lax-opacity="0 1, 200 0">
                                <h1 data-aos="zoom-out" data-aos-easing="ease-in" data-aos-delay="100" data-aos-duration="250">OUR<br/>WORK</h1>
                                <h3 data-aos="zoom-out" data-aos-easing="ease-in" data-aos-delay="250" data-aos-duration="300">Bellow you can find a collection some of our latest projects.</h3>
                            </div>

                            <div class="my-5">
                                <nexticon title='Check it out' vcolor='#000000' :bounce='true'  :delay='200'></nexticon>
                            </div>

                            <div class="bg-circle lax w-100" id="bg-circle" data-lax-scale="200 1.5, 0 1"  data-lax-opacity="0 1, 200 0.3">
                                <svg height="500" class="mx-auto d-block w-100">
                                    <circle cx="200" cy="250" r="200" stroke="" stroke-width="0" fill="#FF6347" opacity="0.4" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div class="projects">
                <div class="container-fluid mx-0 px-0">
                    <div class="row no-gutters project" v-for="project in projects" :key="project.title" :style="{background: project.bcolor}" :id="project.id">
                        <div class="col-sm-12 offset-md-2 col-md-8 p-5">
                            <div data-aos="fade-up" data-aos-easing="ease-in" data-aos-duration="800" data-aos-delay="300" data-aos-anchor-placement="top-bottom" :class="project.id">
                                <h3>{{project.title}}</h3>
                                <img :src="require('@/assets/img/' + project.image)" :alt="project.title" class="project-img img-fluid" />
                                <br />
                                <div v-html="project.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import nexticon from './NextIcon'
import lax from 'lax.js'

export default {
    name: 'Portfolio',
        data () {
            return {
                projects: [
                    {id: '55mais', title: '55 +', content: '<p>55+ was born with the aim of preventing loneliness and inactivity for all those over 55 years of age, providing them with an active life through the provision of quality and trustworthy services in their neighborhoods, which value peoples knowledge. and that create solid and close informal support networks.</p><p><a href="#">www.55mais.pt</a></p>', image: '55mais.png', bcolor: 'rgba(255, 197, 85, 0.4)'},
                    {id: 'loanstar', title: 'LOANSTAR CROWDLENDING', content: '<p>LoanStar is a collective investment platform that links those looking for financing to those who want to invest, diversifying projects and investments that cross, and giving rise to completely independent investments. A simple and transparent process, which distances itself from the conventional financial system, managed through the app and the website. The future of investment in everyones hands</p><p><a href="#">www.loanstar.pt</a></p>', image: 'loanstar.png', bcolor: 'rgba(105,197,217,0.51)'},
                    {id: 'portaljuridico', title: 'PORTAL JURÍDICO', content: '<p>Loreem ipsum bla blab bla bla</p><p><a href="#">www.portaljuridico.pt</a></p>', image: 'portaljuridico.png', bcolor: 'rgba(132,52,74,0.20)'},
                    {id: 'thebrusco', title: 'Brusco', content: '<p>#criticalsurfgear</p><p>#criticalsurfgear</p><p><a href="#">www.thebrusco.com</a></p>', image: '55mais.png', bcolor: 'rgba(21, 34, 56, 0.7)'}
                ]
            }
        },
        mounted: function () {
            lax.addElement(document.getElementById('header-text'))
            lax.addElement(document.getElementById('bg-circle'))
        },
        components: {
            nexticon
        }
    }
</script>

<style lang="scss">
header.punchline{
    text-align: left; overflow: hidden;
    h1{
        color: #2c3e50; font-size: 100px; font-weight:bold;
    }
    h3{font-size: 32px; font-weight: 200; color: #2c3e50;}
}

.project{
    display: block;
    h3{
        font-size: 40px; font-weight:700;
    }
    img.project-img{
        max-height:500px;
    }
    a{
        color:$orange!important;
    }
}

.bg-circle {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
}
</style>
